import { createContext, useContext, useEffect, useState } from "react";
import {
  SERVICES, SERVICES_EN,
  PROJECTS, PROJECTS_EN,
  CHAPTERS, CHAPTERS_EN,
  PILLARS, PILLARS_EN,
  MARQUEE_ITEMS, MARQUEE_ITEMS_EN,
  STATS, STATS_EN,
  FAQS, FAQS_EN,
} from "@/data/content";

export const NAV_ITEMS = [
  { to: "/", key: "navHome", testid: "home" },
  { to: "/servizi", key: "navServizi", testid: "servizi" },
  { to: "/progetti", key: "navProgetti", testid: "progetti" },
  { to: "/chi-siamo", key: "navChiSiamo", testid: "chi-siamo" },
  { to: "/contatti", key: "navContatti", testid: "contatti" },
];

const STRINGS = {
  it: {
    navHome: "Home", navServizi: "Servizi", navProgetti: "Progetti", navChiSiamo: "Chi Siamo", navContatti: "Contatti",
    navCta: "Preventivo WhatsApp",
    heroEyebrow: "Impresa Edile — Lucca · dal 1994",
    heroL1: "L'arte di", heroL2: "costruire.", heroL3: "La precisione", heroL4: "di abitare.",
    heroSub: "Costruzioni residenziali di pregio, ristrutturazioni chiavi in mano, restauri e piscine a Lucca e in tutta la Toscana. Trent'anni di esperienza, rinnovati nel 2020.",
    heroCtaQuote: "Richiedi un preventivo", heroCtaProjects: "Scopri i progetti",
    servicesEyebrow: "I nostri servizi",
    servicesTitleA: "Soluzioni complete,", servicesTitleB: "chiavi in mano",
    viewAllServices: "Tutti i servizi", discover: "Scopri",
    quoteA: '"Ogni cantiere è una promessa.', quoteB: ' Ogni dettaglio, la nostra firma."',
    pillarsEyebrow: "Perché scegliere Edilcomplex2020",
    projectsEyebrow: "Progetti recenti",
    projectsTitleA: "Opere che", projectsTitleB: "parlano da sole",
    viewAllProjects: "Scoprili tutti",
    reviewTitlePre: "Valutazione", reviewTitleAccent: "5.0 su 5", reviewTitlePost: "su Google",
    reviewBy: "Recensione a 5 stelle · Google Maps",
    reviewLink: "Leggi le recensioni su Google",
    ctaEyebrow: "Iniziamo a costruire",
    ctaTitleA: "Hai un progetto", ctaTitleB: "in mente?",
    ctaSub: "Raccontacelo su WhatsApp: ti risponderemo in giornata con un primo confronto gratuito.",
    ctaWhatsApp: "Scrivici su WhatsApp", ctaContacts: "Tutti i contatti",
    serviziHeroEyebrow: "I nostri servizi",
    serviziL1: "Ogni progetto,", serviziL2: "la nostra firma.",
    serviziSub: "Soluzioni complete chiavi in mano: progettazione su misura, costruzione e ristrutturazione, gestione e supervisione del cantiere, assistenza e manutenzione.",
    serviceLabel: "Servizio", serviceCta: "Richiedi preventivo",
    waServiceMsg: "Buongiorno Edilcomplex2020, vorrei informazioni sul servizio:",
    methodEyebrow: "Il nostro metodo",
    methodTitleA: "Dalla progettazione", methodTitleB: "all'arredamento",
    method1: "Progettazione su misura con tecnici qualificati",
    method2: "Costruzione e ristrutturazione chiavi in mano",
    method3: "Gestione e supervisione continua del cantiere",
    method4: "Assistenza e manutenzione post-consegna",
    progettiHeroEyebrow: "I nostri progetti",
    progettiL1: "Opere recenti,", progettiL2: "dettagli eterni.",
    progettiSub: "Ogni lavoro è personalizzato per rispondere alle esigenze del cliente, dalla progettazione alla consegna finale. Lasciati ispirare dalle nostre realizzazioni più recenti.",
    nextEyebrow: "Il prossimo progetto?", nextTitleA: "Potrebbe essere", nextTitleB: "il tuo.",
    projectsCta: "Raccontacelo su WhatsApp",
    waProjectsMsg: "Buongiorno Edilcomplex2020, ho visto i vostri progetti e vorrei parlarvi del mio.",
    photo: "foto",
    aboutHeroEyebrow: "Chi siamo",
    aboutL1: "Trent'anni di materia,", aboutL2: "una nuova era.",
    aboutSub: "Edilcomplex2020 unisce tre decenni di esperienza edilizia a tecnologie all'avanguardia: soluzioni complete, dalla progettazione all'arredamento finale, in tutta la Toscana.",
    manifesto: "Il manifesto", chapterLabel: "Capitolo",
    valuesEyebrow: "I nostri valori", valuesTitleA: "Quello in cui", valuesTitleB: "crediamo",
    aboutCta: "Guarda cosa abbiamo costruito",
    contactsHeroEyebrow: "Contatti",
    contactsL1: "Parliamo del", contactsL2: "tuo progetto.",
    contactsSub: "Siamo qui per assisterti in ogni fase, dalla pianificazione alla realizzazione finale. Scrivici: ti risponderemo in giornata.",
    recapiti: "Recapiti utili", reachableA: "Sempre", reachableB: "raggiungibili",
    labelPhone: "Telefono / WhatsApp", labelEmail: "Email", labelAddress: "Sede", labelHours: "Orari",
    chatDirect: "Chat diretta",
    formEyebrow: "Inviaci un messaggio",
    formTitleA: "Il messaggio arriva", formTitleB: "diretto su WhatsApp",
    formSub: "Compila il form: apriremo WhatsApp con il messaggio già pronto da inviare.",
    labelName: "Nome e Cognome *", placeholderName: "Mario Rossi",
    labelPhoneField: "Telefono", labelService: "Servizio di interesse",
    selectService: "Seleziona un servizio", other: "Altro",
    labelMessage: "Messaggio *",
    placeholderMsg: "Raccontaci il tuo progetto: tipo di intervento, località, tempistiche...",
    privacyA: "Dichiaro di aver letto e accettato", privacyLink: "l'informativa sulla privacy",
    submitBtn: "Invia su WhatsApp", sending: "Apertura WhatsApp...",
    toastSent: "Perfetto! Si sta aprendo WhatsApp con il tuo messaggio già pronto.",
    waHeader: "*Nuova richiesta dal sito*", waName: "Nome", waPhone: "Telefono", waService: "Servizio", waMessage: "Messaggio",
    cookieTitle: "Rispettiamo la tua privacy",
    cookieText: "Questo sito utilizza cookie tecnici necessari al funzionamento e, solo con il tuo consenso, cookie analitici di Google Analytics per statistiche aggregate sulle visite. Puoi modificare la tua scelta in qualsiasi momento. Dettagli nella",
    cookieAccept: "Accetta",
    cookieReject: "Rifiuta",
    cookiePrefs: "Preferenze cookie",
    footerTagline: "Impresa edile a Lucca. Costruzioni residenziali, ristrutturazioni chiavi in mano, restauri e piscine di pregio in tutta la Toscana, dal 1994.",
    footerNav: "Navigazione", footerContacts: "Contatti",
    footerSectors: "Costruzioni · Ristrutturazioni · Restauri · Piscine",
    privacyEyebrow: "Documenti", privacyL1: "Privacy", privacyL2: "Policy.",
    privacySub: "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.",
    privacyEnNoteTitle: "English summary",
    privacyEnNoteText: "This Privacy Policy is provided in Italian as required by EU Regulation 2016/679 (GDPR). In short: Edilcomplex2020 S.r.l. only processes the data you voluntarily submit via the contact form (name, email, phone, message) to respond to your enquiry. No profiling, no third-party cookies, no marketing use. You can request access, correction or deletion of your data at any time at edilcomplex2020@gmail.com.",
    backHome: "Torna alla home",
    lastUpdate: "Ultimo aggiornamento: Settembre 2026",
    cookieL1: "Cookie", cookieL2: "Policy.",
    cookieSub: "Informazioni sui cookie utilizzati da questo sito, ai sensi del Regolamento (UE) 2016/679 e delle Linee guida del Garante Privacy.",
    terminiL1: "Termini e", terminiL2: "Condizioni.",
    terminiSub: "Termini e condizioni d'uso del sito web di Edilcomplex2020 S.r.l.",
    legalEnNoteTitle: "English summary",
    legalEnNoteText: "This page is provided in Italian. In short: this website uses technical cookies (cookie consent and language preference) and, only with your consent, Google Analytics cookies for aggregated statistics; it also shows third-party content from Google Maps. All content and images are property of Edilcomplex2020 S.r.l. For any question about these terms, contact edilcomplex2020@gmail.com.",
  },
  en: {
    navHome: "Home", navServizi: "Services", navProgetti: "Projects", navChiSiamo: "About Us", navContatti: "Contact",
    navCta: "WhatsApp Quote",
    heroEyebrow: "Construction Company — Lucca · since 1994",
    heroL1: "The art of", heroL2: "building.", heroL3: "The precision", heroL4: "of living.",
    heroSub: "Fine residential construction, turnkey renovations, restorations and swimming pools in Lucca and across Tuscany. Thirty years of experience, renewed in 2020.",
    heroCtaQuote: "Request a quote", heroCtaProjects: "Explore our projects",
    servicesEyebrow: "Our services",
    servicesTitleA: "Complete solutions,", servicesTitleB: "turnkey",
    viewAllServices: "All services", discover: "Discover",
    quoteA: '"Every site is a promise.', quoteB: ' Every detail, our signature."',
    pillarsEyebrow: "Why choose Edilcomplex2020",
    projectsEyebrow: "Recent projects",
    projectsTitleA: "Works that", projectsTitleB: "speak for themselves",
    viewAllProjects: "See them all",
    reviewTitlePre: "Rated", reviewTitleAccent: "5.0 out of 5", reviewTitlePost: "on Google",
    reviewBy: "5-star review · Google Maps",
    reviewLink: "Read the reviews on Google",
    ctaEyebrow: "Let's start building",
    ctaTitleA: "Have a project", ctaTitleB: "in mind?",
    ctaSub: "Tell us about it on WhatsApp: we'll reply within the day with a free initial consultation.",
    ctaWhatsApp: "Message us on WhatsApp", ctaContacts: "All contacts",
    serviziHeroEyebrow: "Our services",
    serviziL1: "Every project,", serviziL2: "our signature.",
    serviziSub: "Complete turnkey solutions: bespoke design, construction and renovation, site management and supervision, assistance and maintenance.",
    serviceLabel: "Service", serviceCta: "Request a quote",
    waServiceMsg: "Hello Edilcomplex2020, I would like information about the service:",
    methodEyebrow: "Our method",
    methodTitleA: "From design", methodTitleB: "to furnishing",
    method1: "Bespoke design with qualified technicians",
    method2: "Turnkey construction and renovation",
    method3: "Continuous site management and supervision",
    method4: "After-delivery assistance and maintenance",
    progettiHeroEyebrow: "Our projects",
    progettiL1: "Recent works,", progettiL2: "timeless details.",
    progettiSub: "Every project is tailored to the client's needs, from design to final delivery. Be inspired by our most recent works.",
    nextEyebrow: "The next project?", nextTitleA: "It could be", nextTitleB: "yours.",
    projectsCta: "Tell us about it on WhatsApp",
    waProjectsMsg: "Hello Edilcomplex2020, I saw your projects and I would like to discuss mine.",
    photo: "photo",
    aboutHeroEyebrow: "About us",
    aboutL1: "Thirty years of craft,", aboutL2: "a new era.",
    aboutSub: "Edilcomplex2020 combines three decades of construction experience with cutting-edge technology: complete solutions, from design to final furnishing, throughout Tuscany.",
    manifesto: "The manifesto", chapterLabel: "Chapter",
    valuesEyebrow: "Our values", valuesTitleA: "What we", valuesTitleB: "believe in",
    aboutCta: "See what we've built",
    contactsHeroEyebrow: "Contact",
    contactsL1: "Let's talk about", contactsL2: "your project.",
    contactsSub: "We are here to assist you at every stage, from planning to final delivery. Write to us: we'll reply within the day.",
    recapiti: "Contact details", reachableA: "Always", reachableB: "within reach",
    labelPhone: "Phone / WhatsApp", labelEmail: "Email", labelAddress: "Office", labelHours: "Hours",
    chatDirect: "Direct chat",
    formEyebrow: "Send us a message",
    formTitleA: "Your message goes", formTitleB: "straight to WhatsApp",
    formSub: "Fill in the form: we'll open WhatsApp with your message ready to send.",
    labelName: "Full name *", placeholderName: "John Smith",
    labelPhoneField: "Phone", labelService: "Service of interest",
    selectService: "Select a service", other: "Other",
    labelMessage: "Message *",
    placeholderMsg: "Tell us about your project: type of work, location, timeline...",
    privacyA: "I declare that I have read and accept", privacyLink: "the privacy policy",
    submitBtn: "Send via WhatsApp", sending: "Opening WhatsApp...",
    toastSent: "Perfect! WhatsApp is opening with your message ready to send.",
    waHeader: "*New enquiry from the website*", waName: "Name", waPhone: "Phone", waService: "Service", waMessage: "Message",
    cookieTitle: "We respect your privacy",
    cookieText: "This site uses technical cookies required for it to function and, only with your consent, Google Analytics cookies for aggregate visit statistics. You can change your choice at any time. Details in the",
    cookieAccept: "Accept",
    cookieReject: "Reject",
    cookiePrefs: "Cookie preferences",
    footerTagline: "Construction company in Lucca. Fine residential builds, turnkey renovations, restorations and premium pools throughout Tuscany, since 1994.",
    footerNav: "Navigation", footerContacts: "Contact",
    footerSectors: "Construction · Renovations · Restoration · Pools",
    privacyEyebrow: "Documents", privacyL1: "Privacy", privacyL2: "Policy.",
    privacySub: "Information on the processing of personal data pursuant to Regulation (EU) 2016/679 (GDPR).",
    privacyEnNoteTitle: "English summary",
    privacyEnNoteText: "This Privacy Policy is provided in Italian as required by EU Regulation 2016/679 (GDPR). In short: Edilcomplex2020 S.r.l. only processes the data you voluntarily submit via the contact form (name, email, phone, message) to respond to your enquiry. No profiling, no third-party cookies, no marketing use. You can request access, correction or deletion of your data at any time at edilcomplex2020@gmail.com.",
    backHome: "Back to home",
    lastUpdate: "Last updated: September 2026",
    cookieL1: "Cookie", cookieL2: "Policy.",
    cookieSub: "Information about the cookies used by this website, pursuant to Regulation (EU) 2016/679 and the Italian DPA guidelines.",
    terminiL1: "Terms &", terminiL2: "Conditions.",
    terminiSub: "Terms and conditions of use of the Edilcomplex2020 S.r.l. website.",
    legalEnNoteTitle: "English summary",
    legalEnNoteText: "This page is provided in Italian. In short: this website uses technical cookies (cookie consent and language preference) and, only with your consent, Google Analytics cookies for aggregated statistics; it also shows third-party content from Google Maps. All content and images are property of Edilcomplex2020 S.r.l. For any question about these terms, contact edilcomplex2020@gmail.com.",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ec-lang") || "it");

  useEffect(() => {
    localStorage.setItem("ec-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => STRINGS[lang][key] ?? STRINGS.it[key] ?? key;

  const content =
    lang === "en"
      ? { services: SERVICES_EN, projects: PROJECTS_EN, chapters: CHAPTERS_EN, pillars: PILLARS_EN, marquee: MARQUEE_ITEMS_EN, stats: STATS_EN, faqs: FAQS_EN }
      : { services: SERVICES, projects: PROJECTS, chapters: CHAPTERS, pillars: PILLARS, marquee: MARQUEE_ITEMS, stats: STATS, faqs: FAQS };

  return (
    <LangContext.Provider value={{ lang, setLang, t, content }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLanguage = () => useContext(LangContext);
